export default __webpack_public_path__ + "static/media/contact-us-main-bg.3d0351a1.webp";